import React from 'react';
import {
  Box, Chip, Divider, Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CardWrapper, ButtonOutlined } from '../../UI';
import { EMAILS } from '../../../mocks/processos.mock';
import * as C from '../../../theme/colors.constants';

/**
 * Aba E-mail.
 *
 * Print `grid_check_email.png`: chip cinza com a data do dia, e abaixo a lista
 * de e-mails com bolinha, metadados em negrito e o corpo preservando as quebras
 * de linha originais (`white-space: pre-line`).
 */
export default function AbaEmail() {
  return (
    <Box>
      <Box sx={{
        display: 'flex', justifyContent: 'flex-end', mb: 1.5, px: 0.5,
      }}
      >
        <ButtonOutlined startIcon={<AddIcon />}>NOVO</ButtonOutlined>
      </Box>

      <CardWrapper>
        {EMAILS.map(grupo => (
          <Box key={grupo.dia}>
            <Chip
              label={grupo.dia}
              sx={{
                backgroundColor: C.warmGrey,
                color: C.white,
                fontWeight: 700,
                borderRadius: 1.5,
                mb: 2,
              }}
            />

            {grupo.itens.map((e, i) => (
              <Box key={`${e.data}-${i}`}>
                <Box sx={{ display: 'flex', gap: 1.5, py: 1.5 }}>
                  <Box
                    sx={{
                      width: 9,
                      height: 9,
                      borderRadius: '50%',
                      backgroundColor: C.navy,
                      mt: 0.75,
                      flexShrink: 0,
                    }}
                  />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography variant="body2">
                      <Box component="span" sx={{ fontWeight: 700 }}>Data: </Box>
                      {e.data}
                    </Typography>
                    <Typography variant="body2">
                      <Box component="span" sx={{ fontWeight: 700 }}>Autor: </Box>
                      {e.autor}
                    </Typography>
                    <Typography variant="body2">
                      <Box component="span" sx={{ fontWeight: 700 }}>Fase Atual: </Box>
                      {e.faseAtual}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      <Box component="span" sx={{ fontWeight: 700 }}>E-mail: </Box>
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: 'pre-line', color: C.black, mt: 0.25 }}
                    >
                      {e.corpo}
                    </Typography>
                  </Box>
                </Box>
                {i < grupo.itens.length - 1 ? <Divider /> : null}
              </Box>
            ))}
          </Box>
        ))}
      </CardWrapper>
    </Box>
  );
}
